import { css, cx } from '@emotion/css'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { ScanBtnProps } from '../../../types/props'
import { VyuTheme } from '../../../theme/types'
import { RootState } from '../../../types/state'

const getStyle = (theme: VyuTheme) => {
  return css({
    color: theme.colors.v1?.btnText,
    backgroundColor: theme.colors.v1?.primary,
    fontFamily: theme.fonts?.v1?.primary.family,
  })
}

const ScanBtn = ({ switchPage, brandEngagement }: ScanBtnProps) => {
  const intl = useIntl()

  const vyuTheme = useSelector((state: RootState) => state.theme)

  const priStyle = getStyle(vyuTheme)
  return (
    <button
      onClick={switchPage}
      style={brandEngagement?.button?.scanAgainBtn?.style}
      className={cx(priStyle, 'app-card__btn')}
    >
      {brandEngagement?.theme?.messages?.['v1.Decide.ScanAgainButton'] ??
        intl.formatMessage({ id: 'v1.Decide.ScanAgainButton' })}
    </button>
  )
}

export default ScanBtn
